import { UserCreateDTO, UserUpdateDTO, User, BloodType } from "../types/user.types";
import { RolesEnum } from "../types/route.types";

export const DEFAULT_USER_CREATE_DTO: UserCreateDTO = {
  email: "",
  firstName: "",
  lastName: "",
  role: RolesEnum.USER,
  companyId: 0,
};


export const mapUserToUpdateDTO = (user: User): UserUpdateDTO => ({
  firstName: user.firstName,
  lastName: user.lastName,
  role: user.role === 'admin' ? RolesEnum.ADMIN :
    user.role === 'manager' ? RolesEnum.MANAGER :
      RolesEnum.USER,
  title: user.title || "",
  phone: user.phone || "",
  emergencyContact: user.emergencyContact || "",
  hireDate: new Date(user.hireDate),
  birthDate: user.birthDate ? new Date(user.birthDate) : undefined,
  maritalStatus: user.maritalStatus || undefined,
  educationLevel: user.educationLevel || undefined,
  gender: user.gender || undefined,
  city: user.city || "",
  nationalId: user.nationalId || "",
  department: user.department?.[0]?.id || null, 
  branch: user.branch?.[0]?.id || null,
  annualLeaveLimit: user.annualLeaveLimit || 0,
  isFixedShift: user.isFixedShift,
  workDuration: user.workDuration,
  profilePicture: user.profilePicture,
  status: user.status as 'active' | 'inactive' | 'suspended',
  bloodType: user.bloodType|| undefined,
  chronicDiseases: user.chronicDiseases || [],
});

export const REQUIRED_USER_FIELDS: (keyof UserCreateDTO)[] = [
  'email',
  'firstName',
  'lastName',
  'role',
];

export const ROLES = [
  { value: "admin", label: "Admin" },
  { value: "manager", label: "Manager" },
  { value: "user", label: "User" },
];

export const GENDERS = [
  { value: "male", label: "Erkek" },
  { value: "female", label: "Kadın" },
  { value: "other", label: "Diğer" },
]; 